module.exports = __webpack_public_path__ + "img/maj3.5a0ece3f.jpg";